import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './locales/i18n'; // Initialize i18n
import AgeRangeModal from './components/AgeRangeModal/AgeRangeModal';
import AuthCallback from './components/AuthCallback';
import DisclaimerModal from './components/DisclaimerModal/DisclaimerModal';
import FeedbackFlow from './components/FeedbackFlow/FeedbackFlow';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import WelcomeToast from './components/WelcomeToast/WelcomeToast';
import { LanguageProvider } from './contexts/LanguageContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import AboutUs from './pages/AboutUs/AboutUs';
import Chat from './pages/Chat/Chat';
import CompanionProfile from './pages/CompanionProfile/CompanionProfile';
import Contact from './pages/Contact/Contact';
import Disclaimer from './pages/Disclaimer/Disclaimer';
import FAQ from './pages/FAQ/FAQ';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import LandingPage from './pages/LandingPage/LandingPage';
import Login from './pages/Login/Login';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Register from './pages/Register/Register';
import DeleteAccount from './pages/Settings/DeleteAccount';
import Settings from './pages/Settings/Settings';
import Sponsor from './pages/Sponsor/Sponsor';
import SponsorDetail from './pages/SponsorDetail/SponsorDetail';
import Subscription from './pages/Subscription/Subscription';
import TermsOfService from './pages/TermsOfService/TermsOfService';

function App() {
  return (
    <LanguageProvider>
      <SubscriptionProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <AgeRangeModal />
            <DisclaimerModal />
            <FeedbackFlow />
            <WelcomeToast />
            <Routes>
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Landing Page */}
              <Route path="/" element={<LandingPage />} />

              {/* Companion Pages */}
              <Route path="/companion/:companionId" element={<CompanionProfile />} />
              <Route path="/chat/:companionId" element={<Chat />} />

              {/* Settings */}
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/delete-account" element={<DeleteAccount />} />

              {/* Subscription */}
              <Route path="/subscription" element={<Subscription />} />

              {/* Sponsor */}
              <Route path="/sponsor" element={<Sponsor />} />
              <Route path="/sponsor/:sponsorId" element={<SponsorDetail />} />

              {/* Info Pages */}
              <Route path="/about" element={<AboutUs />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />

              {/* Legal Pages */}
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
            </Routes>
          </div>
        </Router>
      </SubscriptionProvider>
    </LanguageProvider>
  );
}

export default App;
